export default "__VITE_ASSET__b20d2c4a__"